module.exports = __webpack_public_path__ + "static/media/4.7733d6fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/tmsAbout/img/4.png
// module id = 438
// module chunks = 0